import React, { useEffect, useState } from 'react'
import { Grid, IconButton } from '@mui/material'
import { Info } from '@mui/icons-material'
import { connect } from 'react-redux'
import * as organization from '../../../../appRedux/actions/fuel_request/organization'
import FuelRequestComplete from '../../../../components/fuel_request/completed'
import SalesDetails from '../../../../components/sales_details'
import BlankPage from '../../../../components/blank_page'
import IntlMessages from '../../../../util/IntlMessages'
import Comeback from '../../../../components/comeback'
import * as router from '../../../../constants/router'
import * as constants from '../../../../constants'

function Organization(props) {
    const [showDetails, setShowDetails] = useState(false)

    useEffect(() => {
        props.operatorFuelRequestOrganizationHistoryAction()
    }, [])

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={6} md={6}>
                    <Comeback title={<IntlMessages id="onlineOrganization" />} redirectLink={router.SALES} />
                </Grid>
                <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
                    <IconButton onClick={() => setShowDetails(!showDetails)}>
                        <Info />
                    </IconButton>
                </Grid>
            </Grid>
            {props.list.length === 0 ?
                <BlankPage type={constants.BLANK_PAGE_FUEL_REQUEST_ORGANIZATION} />
                : props.list.map((fuelRequestDetails, index) => (
                    <FuelRequestComplete type="organization" key={index} {...fuelRequestDetails} />
                ))
            }
            <br />
            <br />
            <br />
            <SalesDetails
                type="organization"
                showDetails={showDetails}
                setShowDetails={() => setShowDetails(!showDetails)} />
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        list: state.field.list
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        operatorFuelRequestOrganizationHistoryAction: () =>
            dispatch(organization.operatorFuelRequestOrganizationHistoryAction())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Organization)
